
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"-1 -1 40 40","xmlns":"http://www.w3.org/2000/svg","stroke":"#fff"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(1 1)","stroke-width":"4","fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"stroke":"#C1E7FF","stroke-opacity":".5","cx":"18","cy":"18","r":"18"}}),_c('path',{attrs:{"stroke":"#4788C6","d":"M36 18c0-9.94-8.06-18-18-18"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","from":"0 18 18","to":"360 18 18","dur":"1s","repeatCount":"indefinite"}})])])])
          )
        }
      }
    